import cloneDeep from 'lodash/cloneDeep';

import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { generateFormObject } from '@/core/tools/forms/generate_form_object';
import { prepareFormObjectForSave } from '@/core/tools/forms/prepare_form_object_for_save';

interface TransportCostsManyFormState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    forms: any[];
    schema: any;

    meta: any;
}

const state: TransportCostsManyFormState = {
    loading: false,
    loaded: false,
    fatalError: false,

    forms: [],
    schema: null,

    meta: {},
};

const initState: TransportCostsManyFormState = cloneDeep(state);

export const TRANSPORT_COSTS_DATA = 'GET_TRANSPORT_COSTS_MANY_DATA';
export const TRANSPORT_COSTS_SCHEMA = 'GET_TRANSPORT_COSTS_MANY_SCHEMA';

export const actions: ActionTree<TransportCostsManyFormState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    init({ commit, dispatch }, params) {
        return dispatch('loadData', params);
    },

    prepareNew({ commit, state }) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(TRANSPORT_COSTS_SCHEMA)
                    .raw('schemas.get')
                    .action({
                        id: `s:transport_costs`
                    }),
            ]).then((result: ServerResult) => {
                commit('GENERATE_FORM_DATA', {
                    ...result.getOperation(TRANSPORT_COSTS_SCHEMA).getContent(),
                });

                commit('LOADED_SUCCESS');
                resolve();
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    saveForm({ commit }, documentId) {
        const vm = (this as any)._vm;

        const forms = state.forms.map((form: any) => {
            return prepareFormObjectForSave(state.schema, form)
        })

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const saveQueries = forms.map((form: any, idx: number) => {
                return vm.$q('TRANSPORT_COSTS_DATA_SAVE_' + idx)
                    .create('s:transport_costs', form)
            });

            vm.$db(saveQueries).then((result: ServerResult) => {
              resolve({});
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        })
    },

    addForm({commit}) {
        commit('ADD_FORM')
    },

    copyForm({commit}, {idx}) {
        commit('COPY_FORM', {idx})
    },


    delForm({commit}, {idx}) {
        commit('DEL_FORM', {idx})
    },

    changeFormValue({commit}, {index, field, newValue}) {
        commit('CHANGE_VALUE', {index, field, newValue});
    },

};

export const mutations: MutationTree<TransportCostsManyFormState> = {
    RESET_STATE: (state) => {
        for(const key in initState) {
            (state as any)[key] = (initState as any)[key]
        }
    },

    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },

    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },

    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    ADD_FORM(state) {
        state.forms.push(generateFormObject(state.schema, {}))
    },

    COPY_FORM(state, {idx}) {
        state.forms.push(generateFormObject(state.schema, {...state.forms[idx]}))
    },

    DEL_FORM(state, {idx}) {
        state.forms.splice(idx, 1)
    },

    SET_FORM_DATA(state, {document, schema}) {
        state.schema = schema;
        state.meta = fetchEnumsFromSchema(schema);

        state.forms.push(generateFormObject(schema, {}));
    },

    GENERATE_FORM_DATA(state, {schema}) {
        state.schema = schema;
        state.meta = fetchEnumsFromSchema(schema);

        state.forms.push(generateFormObject(schema, {}));
    },

    CHANGE_VALUE(state: TransportCostsManyFormState, {index, field, newValue}) {
        switch (field) {
            default:
                state.forms[index][field] = newValue;
        }
    },
};

const getters = {
    fields: (state: TransportCostsManyFormState) => {
        return state.schema.fields.reduce((prev: any, field: any) => {
            prev[field.code] = field;
            return prev;
        }, {});
    },
};

export const STORE_KEY = '$_transport_costs_form';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
